(function () {
function init(root) {
if (!root || root.__pq) return;
root.__pq = true;
var sid = root.getAttribute('data-pq');
var DATA = {};
try { DATA = JSON.parse(root.querySelector('script[data-pq-data]').textContent); } catch (e) { return; }
var CFG = DATA.cfg || {};
var PADDLES = DATA.paddles || [];
var ICON = {
seed: '<path d="M12 21v-9"/><path d="M12 12c0-4 3-7 7-7 0 4-3 7-7 7z"/><path d="M12 14c0-3-2.5-5.5-6-5.5 0 3.5 2.5 5.5 6 5.5z"/>',
chart: '<path d="M4 20V11"/><path d="M10 20V5"/><path d="M16 20v-7"/><path d="M21 20H3"/>',
trophy: '<path d="M8 21h8"/><path d="M12 17v4"/><path d="M7 4h10v5a5 5 0 0 1-10 0V4z"/><path d="M17 5h3v2a3 3 0 0 1-3 3"/><path d="M7 5H4v2a3 3 0 0 0 3 3"/>',
crown: '<path d="M3 8l4.5 4L12 5l4.5 7L21 8l-2 11H5L3 8z"/>',
target: '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1.2"/>',
bolt: '<path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z"/>',
spin: '<path d="M21 12a9 9 0 1 1-3-6.7"/><path d="M21 4v5h-5"/>',
grid: '<rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/>',
cross: '<circle cx="12" cy="12" r="7"/><path d="M12 2v5M12 17v5M2 12h5M17 12h5"/>',
flame: '<path d="M12 22c4 0 7-3 7-7 0-4-3-6-4-9-1 2-2 3-4 3 0-2-1-4-3-5 0 4-3 6-3 11 0 4 3 7 7 7z"/>',
plus: '<circle cx="12" cy="12" r="9"/><path d="M12 8v8M8 12h8"/>',
shield: '<path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6l8-3z"/>',
pulse: '<path d="M2 12h4l3-7 4 14 3-7h6"/>',
dots: '<circle cx="5" cy="12" r="1.4"/><circle cx="12" cy="12" r="1.4"/><circle cx="19" cy="12" r="1.4"/>',
reach: '<path d="M12 2v20"/><path d="M8 6l4-4 4 4"/><path d="M8 18l4 4 4-4"/>',
expand: '<path d="M4 9V4h5"/><path d="M20 9V4h-5"/><path d="M4 15v5h5"/><path d="M20 15v5h-5"/>',
tag: '<path d="M3 12V4a1 1 0 0 1 1-1h8l9 9-9 9-9-9z"/><circle cx="8" cy="8" r="1.4"/>',
gem: '<path d="M6 3h12l3 6-9 12L3 9l3-6z"/><path d="M3 9h18M9 3l3 18M15 3l-3 18"/>',
clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
calendar: '<rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 10h18M8 3v4M16 3v4"/>',
shuffle: '<path d="M3 7h3.5l11 10H21"/><path d="M3 17h3.5l3-2.7"/><path d="M14.5 9.7L17.5 7H21"/><path d="M18 4l3 3-3 3"/><path d="M18 14l3 3-3 3"/>',
check: '<path d="M5 12.5l4.5 4.5L19 7.5"/>',
truck: '<path d="M3 6h11v10H3z"/><path d="M14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/>',
refresh: '<path d="M3 12a9 9 0 0 1 15.5-6.2L21 8"/><path d="M21 3v5h-5"/><path d="M21 12a9 9 0 0 1-15.5 6.2L3 16"/><path d="M3 21v-5h5"/>',
badge: '<circle cx="12" cy="9" r="6"/><path d="M8.5 14L7 22l5-3 5 3-1.5-8"/>',
gift: '<rect x="3" y="8" width="18" height="4" rx="1"/><path d="M5 12v9h14v-9M12 8v13"/><path d="M12 8c-2-4-6-4-6-1.5S9 8 12 8zM12 8c2-4 6-4 6-1.5S15 8 12 8z"/>',
info: '<circle cx="12" cy="12" r="9"/><path d="M12 11v6M12 7.5v.5"/>',
link: '<path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1"/><path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1"/>',
star: '<path d="M12 3l2.8 5.7 6.2.9-4.5 4.4 1.1 6.2L12 17.3 6.4 20.2l1.1-6.2L3 9.6l6.2-.9L12 3z"/>',
arrow: '<path d="M5 12h14M13 6l6 6-6 6"/>'
};
function ic(n) { return '<svg class="i" viewBox="0 0 24 24" aria-hidden="true">' + (ICON[n] || '') + '</svg>'; }
var DIMS = ['power', 'control', 'spin', 'forgive', 'speed', 'feel', 'ease', 'ceiling'];
var DIM_LABEL = { power: 'Power', control: 'Control', spin: 'Spin', forgive: 'Forgiveness', speed: 'Hand speed', feel: 'Feedback', ease: 'Ease of play', ceiling: 'Performance' };
var LEAD = {
power: 'You win with pace.', control: 'You win at the kitchen.', spin: 'Spin is your weapon.',
forgive: 'Mishits were costing you.', speed: 'You want quick hands.', feel: 'You want to feel the ball.',
ease: 'You are still building your game.', ceiling: 'You play at a high level.'
};
var SOFT = {
power: 'Pace when you need it.', control: 'Touch to match.', spin: 'Spin on tap.', forgive: 'Margin for error.',
speed: 'Quick in the hand.', feel: 'Real feedback.', ease: 'Easy to learn.', ceiling: 'Room to grow.'
};
var QS = [
{ id: 'level', t: 'Where is your game right now?', h: 'Be honest. Nobody is checking your DUPR.', why: 'Newer players need margin for error. Stronger players need a higher ceiling.', o: [
{ v: 'new', l: 'Just getting started', s: 'Playing for under six months', i: 'seed', w: { ease: 3, forgive: 2, control: 1 }, t: ['new'] },
{ v: 'rec', l: 'Regular rec player', s: 'A few times a week, around 3.0 to 3.5', i: 'chart', w: { forgive: 1, control: 1, ease: 1, spin: .5 } },
{ v: 'comp', l: 'Competitive', s: 'Leagues and ladders, 3.5 to 4.5', i: 'trophy', w: { spin: 1, power: 1, ceiling: 1.5, control: .5 } },
{ v: 'adv', l: 'Advanced', s: 'Tournaments, 4.5 and up', i: 'crown', w: { ceiling: 3, spin: 1.5, power: 1 }, t: ['adv'] }
]},
{ id: 'win', t: 'Where do you win most of your points?', h: 'A paddle should amplify what already works for you.', why: 'This sets the balance between power and control in your match.', o: [
{ v: 'kitchen', l: 'At the kitchen line', s: 'Dinks, drops and resets', i: 'target', w: { control: 3, feel: 1.5, forgive: .5 }, t: ['kitchen', 'control'] },
{ v: 'drives', l: 'Driving and putting it away', s: 'Pace from the baseline, finishing at the net', i: 'bolt', w: { power: 3, speed: 1 }, t: ['power'] },
{ v: 'spin', l: 'With spin', s: 'Topspin drives, rolls and spin serves', i: 'spin', w: { spin: 3, power: .5, feel: .5 }, t: ['spin'] },
{ v: 'all', l: 'All over the court', s: 'A bit of everything', i: 'grid', w: { control: 1.5, power: 1.5, spin: 1, forgive: 1 }, t: ['all'] }
]},
{ id: 'miss', t: 'What is your current paddle getting wrong?', h: 'The fix is almost always in the core.', why: 'Your biggest frustration tells us which part of the build matters most.', o: [
{ v: 'offcenter', l: 'Mishits die off the face', s: 'Anything off-center comes off dead', i: 'cross', w: { forgive: 3.5 }, t: ['forgive'] },
{ v: 'nopop', l: 'Not enough pop', s: 'I swing hard and the ball sits up', i: 'bolt', w: { power: 2.5, speed: .5 }, t: ['power'] },
{ v: 'long', l: 'Too hot to control', s: 'Drops and dinks sail long', i: 'flame', w: { control: 2.5, feel: 1 }, t: ['control', 'flieslong'] },
{ v: 'worn', l: 'The spin is gone', s: 'The face has worn smooth', i: 'spin', w: { spin: 2.5 }, t: ['spin', 'worn'] },
{ v: 'none', l: 'I do not have one yet', s: 'This will be my first real paddle', i: 'plus', w: { ease: 2, forgive: 1 }, t: ['new'] }
]},
{ id: 'feel', t: 'How do you want contact to feel?', h: 'No wrong answer here. Different cores feel different.', why: 'Foam cores feel solid and even. Honeycomb feels crisp and gives more feedback.', o: [
{ v: 'solid', l: 'Solid and consistent', s: 'The same response everywhere on the face', i: 'shield', w: { forgive: 2, feel: -1 }, t: ['solid'] },
{ v: 'crisp', l: 'Crisp and connected', s: 'I want to feel exactly where the ball went', i: 'pulse', w: { feel: 3, control: .5 }, t: ['crisp'] },
{ v: 'hot', l: 'Explosive', s: 'Maximum pop, the faster the better', i: 'flame', w: { power: 2.5, speed: 1.5 }, t: ['power', 'hot'] },
{ v: 'unsure', l: 'Not sure yet', s: 'Recommend what fits my game', i: 'dots', w: { ease: .5 } }
]},
{ id: 'shape', t: 'Reach, or a bigger hitting area?', h: 'Elongated shapes add reach. Wider shapes add forgiveness.', why: 'Shape changes where the sweet spot sits and how the paddle swings.', o: [
{ v: 'reach', l: 'Extra reach', s: 'Elongated, for put-aways and two-handed backhands', i: 'reach', w: { power: .5, speed: .5 }, t: ['reach'] },
{ v: 'wide', l: 'A bigger hitting area', s: 'Wider face, the most forgiving shape', i: 'expand', w: { forgive: 2 }, t: ['wide'] },
{ v: 'either', l: 'No preference', s: 'Whatever suits my game', i: 'dots', w: {} }
]},
{ id: 'budget', t: 'What do you want to spend?', h: 'Every CPX paddle ships free and comes with a 90-day money-back guarantee.', why: 'We only recommend a paddle over your budget when nothing else comes close.', o: [
{ v: 'u120', l: 'Under $120', s: 'Best value', i: 'tag', max: 120, t: ['value'] },
{ v: 'mid', l: '$120 to $200', s: 'The sweet spot for most players', i: 'tag', max: 200 },
{ v: 'high', l: '$200 to $300', s: 'Premium builds', i: 'gem', max: 300, w: { ceiling: 1 } },
{ v: 'best', l: 'Whatever it takes', s: 'Show me the best you make', i: 'crown', max: 0, w: { ceiling: 2 }, t: ['best'] }
]},
{ id: 'when', t: 'When do you need it?', h: CFG.timingHelp, why: 'This decides between a build that ships today and our pre-order pricing.', o: [
{ v: 'now', l: 'As soon as possible', s: 'Ship it today', i: 'truck', t: ['now'] },
{ v: 'wait', l: 'I can wait for a better price', s: 'A couple of weeks is fine', i: 'calendar', t: ['wait'] },
{ v: 'flex', l: 'No rush either way', s: '', i: 'shuffle' }
]}
];
function pairs(str) {
var o = {};
String(str || '').split(',').forEach(function (p) { var i = p.indexOf(':'); if (i < 1) return; var k = p.slice(0, i).trim().toLowerCase(); if (k) o[k] = parseFloat(p.slice(i + 1)) || 0; });
return o;
}
function rules(str) {
return String(str || '').split('|').map(function (p) {
var b = p.split(':'); if (b.length < 2) return null;
var w = b.length > 2 ? parseFloat(b[2]) : 1;
return { tag: b[0].trim().toLowerCase(), match: b[1].trim().toLowerCase(), w: isNaN(w) ? 1 : w };
}).filter(function (x) { return x && x.match; });
}
function proofs(str) {
var o = {};
String(str || '').split(/\r?\n/).forEach(function (line) { var i = line.indexOf('='); if (i < 1) return; o[line.slice(0, i).trim().toLowerCase()] = line.slice(i + 1).trim(); });
return o;
}
function profile(ans) {
var W = {}, tags = [], max = Infinity;
DIMS.forEach(function (d) { W[d] = 0; });
QS.forEach(function (q, i) {
var o = q.o[ans[i]]; if (!o) return;
if (o.w) Object.keys(o.w).forEach(function (d) { W[d] += o.w[d]; });
if (o.t) tags = tags.concat(o.t);
if (o.max !== undefined) max = o.max > 0 ? o.max : Infinity;
});
return { W: W, tags: tags, max: max, has: function (t) { return tags.indexOf(t) > -1; } };
}
function pickVariant(p, prof) {
var rs = rules(p.rules), best = null;
var preKey = String(p.preKey || '').toLowerCase();
p.variants.forEach(function (v) {
if (!v.avail) return;
var t = v.title.toLowerCase(), sc = 0;
rs.forEach(function (r) { if (t.indexOf(r.match) === -1) return; if (r.tag === 'default') sc += .2; else if (prof.has(r.tag)) sc += r.w; });
var dollars = v.price / 100, pen = 0;
var over = dollars > prof.max + .5;
if (over) pen -= 3 + (dollars - prof.max) / 20;
var pre = !!preKey && t.indexOf(preKey) > -1;
if (pre && prof.has('now')) pen -= 3;
if (!prof.has('best')) pen -= dollars * .004;
var total = sc + pen;
if (!best || total > best.score) best = { v: v, score: total, pre: pre, over: over };
});
return best;
}
function rank(ans) {
var prof = profile(ans);
var list = PADDLES.map(function (p) {
var fit = 0; DIMS.forEach(function (d) { fit += prof.W[d] * (p.a[d] || 0) / 10; });
var b = pairs(p.bonus), bonus = 0;
prof.tags.forEach(function (t) { if (b[t]) bonus += b[t]; });
var pv = pickVariant(p, prof); if (!pv) return null;
return { p: p, v: pv.v, pre: pv.pre, over: pv.over, s: fit + bonus + (parseFloat(p.boost) || 0) + pv.score };
}).filter(Boolean).sort(function (a, b) { return b.s - a.s; });
if (list.length) {
var top = list[0].s, gap = list.length > 1 ? top - list[1].s : 3;
var winPct = Math.round(Math.max(88, Math.min(98, 89 + gap * 2.2)));
list.forEach(function (r, i) { r.pct = i === 0 ? winPct : Math.round(Math.max(52, Math.min(winPct - 2, winPct - (top - r.s) * 6))); });
}
return { prof: prof, list: list };
}
function reasonsFor(r, prof) {
var pr = proofs(r.p.proofs), out = [];
var ranked = DIMS.filter(function (d) { return prof.W[d] > 0 && pr[d]; })
.map(function (d) { return { d: d, s: prof.W[d] * (r.p.a[d] || 0) }; })
.sort(function (a, b) { return b.s - a.s; });
ranked.slice(0, 3).forEach(function (x) { out.push({ lead: prof.W[x.d] >= 2.5 ? LEAD[x.d] : SOFT[x.d], text: pr[x.d] }); });
return out;
}
function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
function money(cents) {
var parts = (cents / 100).toFixed(2).split('.');
parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
var withDec = parts.join('.'), noDec = parts[0];
if (!CFG.moneyFormat) return '$' + withDec;
return String(CFG.moneyFormat)
.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDec)
.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDec)
.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
.replace(/\{\{\s*amount\s*\}\}/g, withDec)
.replace(/<[^>]*>/g, '');
}
function hexSoft(hex, a) {
var m = /^#?([0-9a-f]{6})$/i.exec(String(hex || '').trim()); if (!m) return '';
var n = parseInt(m[1], 16); return 'rgba(' + (n >> 16 & 255) + ',' + (n >> 8 & 255) + ',' + (n & 255) + ',' + a + ')';
}
function variantUrl(r) { return r.p.url + (r.p.url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + r.v.id; }
function track(name, data) {
data = data || {};
try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('cpx_quiz_' + name, data); } catch (e) {}
try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'cpx_quiz_' + name }, data)); } catch (e) {}
}
function live(msg) { var el = root.querySelector('[data-live]'); if (el) el.textContent = msg; }
function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
var views = {};
root.querySelectorAll('[data-view]').forEach(function (el) { views[el.getAttribute('data-view')] = el; });
var stage = root.querySelector('[data-stage]');
var segs = root.querySelector('[data-segs]');
var countEl = root.querySelector('[data-count]');
var backBtn = root.querySelector('[data-back]');
var resultEl = root.querySelector('[data-result]');
var sticky = root.querySelector('[data-sticky]');
var STORE = 'cpxPaddleQuiz';
var state = { step: 0, ans: [] };
var busy = false, stickyIO = null;
function save() { try { sessionStorage.setItem(STORE, JSON.stringify(state)); } catch (e) {} }
function show(name) {
Object.keys(views).forEach(function (k) { views[k].hidden = k !== name; });
if (sticky && name !== 'result') { sticky.classList.remove('is-on'); sticky.setAttribute('aria-hidden', 'true'); }
}
function scrollTop() {
var y = root.getBoundingClientRect().top + window.pageYOffset - 70;
if (Math.abs(window.pageYOffset - y) > 40) window.scrollTo({ top: Math.max(0, y), behavior: reduced() ? 'auto' : 'smooth' });
}
function paintSegs() {
var html = '';
for (var i = 0; i < QS.length; i++) html += '<span class="pq__seg' + (i < state.step ? ' is-done' : (i === state.step ? ' is-now' : '')) + '"><i></i></span>';
segs.innerHTML = html;
countEl.textContent = (state.step + 1) + ' / ' + QS.length;
backBtn.disabled = false;
}
function renderQ(dir) {
var q = QS[state.step];
var sel = state.ans[state.step];
var cls = q.o.length === 3 ? ' pq__opts--3' : '';
var h = '<div class="pq__q' + (dir === 'back' ? ' is-back' : '') + '">';
h += '<p class="pq__qnum">Question ' + (state.step + 1) + ' of ' + QS.length + '</p>';
h += '<h2 class="pq__qt" id="pqT-' + sid + '" tabindex="-1">' + esc(q.t) + '</h2>';
if (q.h) h += '<p class="pq__qh">' + esc(q.h) + '</p>';
h += '<div class="pq__opts' + cls + '" role="radiogroup" aria-labelledby="pqT-' + sid + '">';
q.o.forEach(function (o, i) {
var on = sel === i;
h += '<button type="button" class="pq__opt" role="radio" aria-checked="' + on + '" tabindex="' + ((sel === undefined ? i === 0 : on) ? 0 : -1) + '" data-i="' + i + '" style="--d:' + i + '">';
h += '<span class="pq__oi">' + ic(o.i) + '</span>';
h += '<span><span class="pq__ol">' + esc(o.l) + '</span>' + (o.s ? '<span class="pq__os">' + esc(o.s) + '</span>' : '') + '</span>';
h += '<span class="pq__ok">' + (on ? ic('check') : '<span>' + (i + 1) + '</span>') + '</span>';
h += '</button>';
});
h += '</div>';
h += '<div class="pq__why">' + ic('info') + '<span>' + esc(q.why) + '</span><span class="pq__keys">Press <kbd>1</kbd> to <kbd>' + q.o.length + '</kbd></span></div>';
h += '</div>';
stage.innerHTML = h;
paintSegs();
live('Question ' + (state.step + 1) + ' of ' + QS.length + '. ' + q.t);
var t = stage.querySelector('.pq__qt'); if (t && dir) { try { t.focus({ preventScroll: true }); } catch (e) {} }
}
function choose(i) {
if (busy) return;
var q = QS[state.step]; if (!q.o[i]) return;
busy = true;
state.ans[state.step] = i;
state.ans.length = Math.max(state.ans.length, state.step + 1);
save();
stage.querySelectorAll('.pq__opt').forEach(function (b) {
var on = parseInt(b.getAttribute('data-i'), 10) === i;
b.setAttribute('aria-checked', on);
var k = b.querySelector('.pq__ok'); if (k) k.innerHTML = on ? ic('check') : '<span>' + (parseInt(b.getAttribute('data-i'), 10) + 1) + '</span>';
});
track('answer', { question: q.id, answer: q.o[i].v, step: state.step + 1 });
setTimeout(function () {
var cur = stage.querySelector('.pq__q'); if (cur) cur.classList.add('is-out');
setTimeout(function () {
busy = false;
if (state.step < QS.length - 1) { state.step++; save(); renderQ('next'); }
else finish();
}, reduced() ? 0 : 200);
}, reduced() ? 0 : 240);
}
function back() {
if (busy) return;
if (state.step === 0) { show('intro'); scrollTop(); return; }
state.step--; save(); renderQ('back');
}
function start() {
state = { step: 0, ans: [] }; save();
show('quiz'); renderQ('next'); scrollTop();
track('start', {});
}
function finish() {
var enc = state.ans.join('');
try { history.replaceState(null, '', location.pathname + location.search + '#r=' + enc); } catch (e) {}
show('calc'); scrollTop();
var lis = root.querySelectorAll('[data-calc-steps] li');
lis.forEach(function (li) { li.classList.remove('is-on'); });
var delay = CFG.design || reduced() ? 60 : 520;
lis.forEach(function (li, i) { setTimeout(function () { li.classList.add('is-on'); }, delay * (i + .6)); });
setTimeout(function () { renderResult(true); }, delay * (lis.length + 1));
}
var current = null;
function shipLine(r) {
if (r.pre) return '<p class="pq__ship">' + ic('clock') + '<span>' + esc(r.p.preNote || 'Pre-order.') + '</span></p>';
return '<p class="pq__ship pq__ship--now">' + ic('truck') + '<span>' + esc(CFG.nowNote) + '</span></p>';
}
function stars(text) {
if (!text) return '';
return '<p class="pq__rating"><span class="pq__stars">' + ic('star') + ic('star') + ic('star') + ic('star') + ic('star') + '</span>' + esc(text) + '</p>';
}
function renderResult(animate) {
var out = rank(state.ans);
if (!out.list.length) { show('intro'); return; }
var prof = out.prof, win = out.list[0], runners = out.list.slice(1, 3);
current = { out: out, win: win };
var p = win.p, v = win.v;
var acc = p.acc || '#ff7634';
var img = v.img || p.img;
var build = v.title && v.title !== 'Default Title' ? v.title.replace(/\s*\(.*\)\s*/, '').trim() : '';
var pctOff = v.compare > v.price ? Math.round((1 - v.price / v.compare) * 100) : 0;
var label = win.pre ? CFG.preLabel : CFG.addLabel;
var circ = 2 * Math.PI * 19;
root.style.setProperty('--p-acc', acc);
root.style.setProperty('--p-glow', hexSoft(acc, .28) || 'rgba(255,118,52,.22)');
root.style.setProperty('--p-soft', hexSoft(acc, .12) || '#fff1ea');
var h = '';
h += '<div class="pq__rtop"><p class="pq__rlabel">' + esc(CFG.resultLabel) + '</p><div class="pq__rtools"><button type="button" class="pq__link" data-share>Copy result link</button><button type="button" class="pq__link" data-restart>Retake quiz</button></div></div>';
h += '<article class="pq__hero">';
h += '<div class="pq__media">';
h += '<div class="pq__match"><svg viewBox="0 0 46 46" aria-hidden="true"><circle class="bg" cx="23" cy="23" r="19"/><circle class="fg" cx="23" cy="23" r="19" stroke-dasharray="' + circ.toFixed(1) + '" stroke-dashoffset="' + (animate ? circ.toFixed(1) : (circ * (1 - win.pct / 100)).toFixed(1)) + '" data-ring="' + (circ * (1 - win.pct / 100)).toFixed(1) + '"/></svg><span><b>' + win.pct + '%</b><small>Match</small></span></div>';
if (p.badge) h += '<span class="pq__badge">' + esc(p.badge) + '</span>';
if (img) h += '<img src="' + esc(img) + '" alt="' + esc(p.name + (build ? ' ' + build : '')) + '" width="900" height="900">';
h += '</div>';
h += '<div class="pq__info">';
if (p.tag) h += '<p class="pq__tag">' + esc(p.tag) + '</p>';
h += '<h2 class="pq__name" tabindex="-1">' + esc(p.name) + '</h2>';
if (build) h += '<p class="pq__build">' + esc(build) + (win.pre ? ' · Pre-order' : '') + '</p>';
h += stars(p.rating);
h += '<div class="pq__pricerow"><span class="pq__price">' + money(v.price) + '</span>';
if (pctOff > 0) h += '<span class="pq__was">' + money(v.compare) + '</span><span class="pq__save">Save ' + pctOff + '%</span>';
h += '</div>';
h += shipLine(win);
if (p.perks) h += '<p class="pq__perks">' + ic('gift') + '<span>' + esc(p.perks) + '</span></p>';
var rs = reasonsFor(win, prof);
if (rs.length) {
h += '<ul class="pq__reasons">';
rs.forEach(function (x) { h += '<li><b>' + ic('check') + '</b><span><strong>' + esc(x.lead) + '</strong> ' + esc(x.text) + '</span></li>'; });
h += '</ul>';
} else if (p.why) {
h += '<ul class="pq__reasons"><li><b>' + ic('check') + '</b><span>' + esc(p.why) + '</span></li></ul>';
}
var cw = String(p.cautionWhen || '').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
var caution = p.caution && cw.some(function (t) { return prof.has(t); });
if (caution) h += '<div class="pq__note">' + ic('info') + '<span>' + esc(p.caution) + '</span></div>';
else if (win.over) h += '<div class="pq__note">' + ic('info') + '<span>This sits above the budget you picked. Nothing under it fit your game as closely, so we would rather be straight with you.</span></div>';
h += '<div class="pq__actions">';
h += '<button type="button" class="pq__btn" data-add="' + v.id + '" data-main>' + ic('arrow') + '<span>' + esc(label) + ' · ' + money(v.price) + '</span></button>';
h += '<a class="pq__btn pq__btn--ghost" href="' + esc(variantUrl(win)) + '" data-view-link>' + esc(CFG.viewLabel) + '</a>';
h += '<p class="pq__err" data-err></p>';
var assure = String(CFG.assure || '').split('|').filter(function (x) { return x.trim(); });
if (assure.length) {
var aic = ['truck', 'refresh', 'badge'];
h += '<p class="pq__assure">' + assure.map(function (x, i) { return '<span>' + ic(aic[i % 3]) + esc(x.trim()) + '</span>'; }).join('') + '</p>';
}
h += '</div></div></article>';
var maxW = 0; ['power', 'control', 'spin', 'forgive', 'feel', 'speed'].forEach(function (d) { if (prof.W[d] > maxW) maxW = prof.W[d]; });
h += '<section class="pq__panel" data-bars>';
h += '<div class="pq__ph"><h3>' + esc(CFG.barsTitle.replace('[paddle]', p.name)) + '</h3><div class="pq__legend"><span><i></i>' + esc(p.name) + '</span><span><i class="you"></i>What you asked for</span></div></div>';
h += '<div class="pq__bars">';
['power', 'control', 'spin', 'forgive', 'feel', 'speed'].forEach(function (d) {
var val = p.a[d] || 0;
var you = maxW > 0 ? Math.max(0, prof.W[d]) / maxW * 10 : 0;
h += '<div class="pq__brow"><span>' + DIM_LABEL[d] + '</span><span class="pq__track"><span class="pq__fill" data-w="' + (val * 10) + '"></span>' + (you > .4 ? '<span class="pq__you" style="left:' + Math.min(99, Math.max(1, you * 10)).toFixed(1) + '%"></span>' : '') + '</span><span>' + (Math.round(val * 10) / 10) + '</span></div>';
});
h += '</div></section>';
if (runners.length) {
h += '<section class="pq__panel"><div class="pq__ph"><h3>' + esc(CFG.runnersTitle) + '</h3></div><div class="pq__runners">';
runners.forEach(function (r) {
var rimg = r.v.img || r.p.img;
var rb = r.v.title && r.v.title !== 'Default Title' ? r.v.title.replace(/\s*\(.*\)\s*/, '').trim() : '';
h += '<div class="pq__run">';
h += '<a class="pq__run-img" href="' + esc(variantUrl(r)) + '" tabindex="-1" aria-hidden="true">' + (rimg ? '<img src="' + esc(rimg.replace('width=900', 'width=300')) + '" alt="" loading="lazy" width="300" height="300">' : '') + '</a>';
h += '<div><div class="pq__run-top"><span class="pq__run-pct">' + r.pct + '% match</span>' + (r.p.tag ? '<span class="pq__run-tag">' + esc(r.p.tag) + '</span>' : '') + '</div>';
h += '<h4>' + esc(r.p.name) + (rb ? ' <span style="font-weight:600;color:var(--cpx-ink-2);font-size:14px;letter-spacing:0">' + esc(rb) + '</span>' : '') + '</h4>';
if (r.p.short) h += '<p>' + esc(r.p.short) + '</p>';
h += '<div class="pq__run-foot"><span class="pq__run-price">' + money(r.v.price) + '</span><a href="' + esc(variantUrl(r)) + '">See it</a><button type="button" data-add="' + r.v.id + '">' + (r.pre ? 'Pre-order' : 'Add') + '</button></div>';
h += '</div></div>';
});
h += '</div></section>';
}
h += '<section class="pq__panel"><details class="pq__all"><summary><h3>' + esc(CFG.compareTitle) + '</h3><span class="pq__plus" aria-hidden="true"></span></summary><div class="pq__grid">';
out.list.slice().sort(function (a, b) { return PADDLES.indexOf(a.p) - PADDLES.indexOf(b.p); }).forEach(function (r) {
var cimg = r.p.img;
h += '<a class="pq__cell' + (r === win ? ' is-win' : '') + '" href="' + esc(variantUrl(r)) + '"><span class="pq__cell-pct">' + r.pct + '%</span><div class="pq__cell-h">' + (cimg ? '<img src="' + esc(cimg.replace('width=900', 'width=160')) + '" alt="" loading="lazy" width="52" height="52">' : '') + '<span><b>' + esc(r.p.name) + '</b><small>From ' + money(Math.min.apply(null, r.p.variants.filter(function (x) { return x.avail; }).map(function (x) { return x.price; }).concat([r.v.price]))) + '</small></span></div><div class="pq__mini">';
['power', 'control', 'spin', 'forgive'].forEach(function (d) { h += '<span>' + DIM_LABEL[d] + '</span><i style="--w:' + ((r.p.a[d] || 0) * 10) + '%"></i>'; });
h += '</div></a>';
});
h += '</div></details></section>';
h += '<div class="pq__foot"><button type="button" class="pq__btn pq__btn--ghost" data-restart>' + ic('refresh') + 'Retake the quiz</button></div>';
resultEl.innerHTML = h;
show('result');
scrollTop();
live('Your match is the ' + p.name + (build ? ', ' + build : '') + ', ' + win.pct + ' percent match.');
var nm = resultEl.querySelector('.pq__name'); if (nm) { try { nm.focus({ preventScroll: true }); } catch (e) {} }
requestAnimationFrame(function () {
requestAnimationFrame(function () {
var ring = resultEl.querySelector('[data-ring]'); if (ring) ring.style.strokeDashoffset = ring.getAttribute('data-ring');
});
});
var panel = resultEl.querySelector('[data-bars]');
function fillBars() { panel.classList.add('is-in'); panel.querySelectorAll('.pq__fill').forEach(function (f) { f.style.width = f.getAttribute('data-w') + '%'; }); }
if ('IntersectionObserver' in window && !reduced()) {
var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { fillBars(); io.disconnect(); } }); }, { threshold: .3 });
io.observe(panel);
} else fillBars();
buildSticky(win, img, label);
if (animate) track('complete', { paddle: p.name, variant: v.title, variant_id: v.id, match: win.pct, answers: state.ans.join('') });
}
function buildSticky(win, img, label) {
if (!sticky) return;
sticky.innerHTML = (img ? '<img src="' + esc(img.replace('width=900', 'width=120')) + '" alt="">' : '') + '<div><b>' + esc(win.p.name) + '</b><small>' + money(win.v.price) + (win.pre ? ' · Pre-order' : '') + '</small></div><button type="button" class="pq__btn" data-add="' + win.v.id + '">' + esc(label) + '</button>';
if (stickyIO) stickyIO.disconnect();
var main = resultEl.querySelector('[data-main]');
if (!main || !('IntersectionObserver' in window)) return;
stickyIO = new IntersectionObserver(function (es) {
es.forEach(function (e) {
var on = !e.isIntersecting && e.boundingClientRect.top < 0 && !views.result.hidden;
sticky.classList.toggle('is-on', on);
sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
});
}, { threshold: 0 });
stickyIO.observe(main);
}
function addToCart(btn) {
var id = parseInt(btn.getAttribute('data-add'), 10);
if (!id || btn.disabled) return;
var err = resultEl.querySelector('[data-err]'); if (err) err.textContent = '';
var original = btn.innerHTML;
btn.disabled = true;
btn.innerHTML = '<span>Adding...</span>';
var match = current && current.out.list.filter(function (r) { return r.v.id === id; })[0];
var item = { id: id, quantity: 1 };
if (CFG.lineProp) { item.properties = {}; item.properties[CFG.lineProp] = 'Paddle quiz' + (match ? ' (' + match.pct + '% match)' : ''); }
fetch(CFG.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: [item] }) })
.then(function (res) { return res.json().then(function (j) { return { ok: res.ok, j: j }; }); })
.then(function (r) {
if (!r.ok) throw new Error((r.j && (r.j.description || r.j.message)) || 'Could not add that to your cart.');
track('add_to_cart', { variant_id: id, paddle: match ? match.p.name : '', match: match ? match.pct : null, rank: match ? current.out.list.indexOf(match) + 1 : null });
btn.classList.add('is-done');
btn.innerHTML = ic('check') + '<span>' + esc(CFG.addedLabel) + '</span>';
document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
var drawer = document.querySelector('cart-drawer');
if (drawer && typeof drawer.show === 'function' && !CFG.redirect) {
setTimeout(function () { try { drawer.show(); } catch (e) { location.href = CFG.cartUrl; } }, 350);
} else {
location.href = CFG.cartUrl;
}
setTimeout(function () { btn.disabled = false; btn.classList.remove('is-done'); btn.innerHTML = original; }, 2600);
})
.catch(function (e) {
btn.disabled = false; btn.innerHTML = original;
if (err) err.textContent = e.message; else alert(e.message);
});
}
function share(btn) {
var url = location.origin + location.pathname + '#r=' + state.ans.join('');
var done = function () { btn.textContent = 'Link copied'; setTimeout(function () { btn.textContent = 'Copy result link'; }, 1800); };
if (navigator.share && /Mobi|Android/i.test(navigator.userAgent)) { navigator.share({ title: document.title, url: url }).catch(function () {}); return; }
if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, function () { prompt('Copy this link', url); });
else prompt('Copy this link', url);
track('share', {});
}
root.addEventListener('click', function (e) {
var t = e.target.closest('button, a'); if (!t || !root.contains(t)) return;
if (t.hasAttribute('data-start')) { start(); return; }
if (t.hasAttribute('data-back')) { back(); return; }
if (t.classList.contains('pq__opt')) { choose(parseInt(t.getAttribute('data-i'), 10)); return; }
if (t.hasAttribute('data-add')) { e.preventDefault(); addToCart(t); return; }
if (t.hasAttribute('data-restart')) { try { history.replaceState(null, '', location.pathname + location.search); } catch (err) {} start(); return; }
if (t.hasAttribute('data-share')) { share(t); return; }
});
root.addEventListener('keydown', function (e) {
if (views.quiz.hidden) return;
if (e.metaKey || e.ctrlKey || e.altKey) return;
var n = parseInt(e.key, 10);
if (n >= 1 && n <= QS[state.step].o.length) { e.preventDefault(); choose(n - 1); return; }
var opts = Array.prototype.slice.call(stage.querySelectorAll('.pq__opt'));
var idx = opts.indexOf(document.activeElement);
if (idx > -1 && /^Arrow(Down|Right|Up|Left)$/.test(e.key)) {
e.preventDefault();
var next = (idx + (/Down|Right/.test(e.key) ? 1 : -1) + opts.length) % opts.length;
opts.forEach(function (o, i) { o.tabIndex = i === next ? 0 : -1; });
opts[next].focus();
}
});
document.addEventListener('keydown', function (e) {
if (views.quiz.hidden || e.metaKey || e.ctrlKey || e.altKey) return;
if (root.contains(document.activeElement)) return;
var tag = (document.activeElement && document.activeElement.tagName) || '';
if (/INPUT|TEXTAREA|SELECT/.test(tag)) return;
var n = parseInt(e.key, 10);
if (n >= 1 && n <= QS[state.step].o.length) choose(n - 1);
});
function validAns(a) { return a.length === QS.length && a.every(function (x, i) { return x >= 0 && x < QS[i].o.length; }); }
var m = /#r=(\d+)/.exec(location.hash || '');
if (m) {
var a = m[1].split('').map(function (x) { return parseInt(x, 10); });
if (validAns(a)) { state = { step: QS.length - 1, ans: a }; renderResult(false); track('shared_view', { answers: m[1] }); return; }
}
if (!CFG.design) {
try {
var saved = JSON.parse(sessionStorage.getItem(STORE) || 'null');
if (saved && saved.ans && saved.ans.length && saved.step < QS.length) {
state = saved;
if (validAns(saved.ans)) { renderResult(false); return; }
show('quiz'); renderQ(); return;
}
} catch (e) {}
}
show('intro');
}
function boot() { document.querySelectorAll('.pq[data-pq]').forEach(init); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
document.addEventListener('shopify:section:load', boot);
})();